import type { ResourceCode } from '@aztec-realms/shared-types';

/** Bundled URLs are fingerprinted by Vite in both consumers; no host-specific asset paths. */
export const resourceArtManifest: Record<ResourceCode, { id: string; url: string }> = {
  maize: {
    id: 'resource-maize-render-v1',
    url: new URL('../assets/resource-maize-render-v1.png', import.meta.url).href,
  },
  stone: {
    id: 'resource-stone-render-v1',
    url: new URL('../assets/resource-stone-render-v1.png', import.meta.url).href,
  },
  timber: {
    id: 'resource-timber-render-v1',
    url: new URL('../assets/resource-timber-render-v1.png', import.meta.url).href,
  },
  jade: {
    id: 'resource-jade-render-v1',
    url: new URL('../assets/resource-jade-render-v1.png', import.meta.url).href,
  },
  knowledge: {
    id: 'resource-knowledge-render-v1',
    url: new URL('../assets/resource-knowledge-render-v1.png', import.meta.url).href,
  },
};
